import { render, staticRenderFns } from "./imgUpload2.vue?vue&type=template&id=73bdd81c&scoped=true&"
import script from "./imgUpload2.vue?vue&type=script&lang=js&"
export * from "./imgUpload2.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload2.vue?vue&type=style&index=0&id=73bdd81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bdd81c",
  null
  
)

export default component.exports